import { useQuery } from '@tanstack/react-query'
import { pasteIntervalFor } from 'pages/Desk/pastePanelState'
import { queryPasteResult } from 'supabase/desk/queryPasteResult'

/**
 * The raw item a paste made and its candidates, re-read every 3000 ms while
 * the raw item is still `new` (pasteIntervalFor) and not at all once the
 * editor has read it. Keyed under 'desk' so a decision (e.g. a Restore from
 * the panel) refreshes it. Deliberately no `refetchIntervalInBackground`.
 */
export const usePasteResult = (rawItemId: number | null) =>
  useQuery({
    queryKey: ['desk', 'paste', rawItemId],
    queryFn: () => queryPasteResult(rawItemId as number),
    enabled: rawItemId !== null,
    refetchInterval: (query) => pasteIntervalFor(query.state.data?.status)
  })
